export default __webpack_public_path__ + "314ae9fa6c1b73f73dc1d0637370e1be.svg";